export const phoneDisplay = '(914) 302-2055';
export const phoneRaw = '19143022055';
export const address = '2041 Saw Mill River Rd, Yorktown Heights, NY 10598';

export const categories = [
  {
    id: 'pizza',
    title: { en: 'Pizza', es: 'Pizza' },
    items: [
      { name: { en: 'Cheese Pizza Slice', es: 'Porción de Pizza de Queso' }, price: '$3.00', desc: { en: 'Slice', es: 'Porción' } },
      { name: { en: 'Pepperoni Pizza Slice', es: 'Porción de Pizza de Pepperoni' }, price: '$4.00', desc: { en: 'Slice', es: 'Porción' } },
      { name: { en: 'Cheese Pizza', es: 'Pizza de Queso' }, price: '$16.00' },
      { name: { en: 'Pepperoni Pizza', es: 'Pizza de Pepperoni' }, price: '$16.00' },
      { name: { en: 'Hawaiian Pizza', es: 'Pizza Hawaiana' }, price: '$16.00', desc: { en: 'X2 Extras', es: 'X2 Extras' } },
      { name: { en: 'Chicken Margarita Pizza', es: 'Pizza Margarita de Pollo' }, price: '$18.00' },
      { name: { en: 'Chicken Marsala Pizza', es: 'Pizza de Pollo Marsala' }, price: '$18.00' },
      { name: { en: 'Chicken Scarpariello Pizza', es: 'Pizza de Pollo Scarpariello' }, price: '$18.00' },
      { name: { en: 'Chicken Caesar Pizza', es: 'Pizza César de Pollo' }, price: '$18.00' },
      { name: { en: 'Buffalo Chicken Pizza', es: 'Pizza de Pollo Buffalo' }, price: '$18.00' },
      { name: { en: 'Philly Cheesesteak Pizza', es: 'Pizza Philly Cheesesteak' }, price: '$18.00' },
      { name: { en: 'BBQ Chicken Pizza', es: 'Pizza de Pollo BBQ' }, price: '$18.00' },
    ],
  },
  {
    id: 'appetizers',
    title: { en: 'Appetizers', es: 'Aperitivos' },
    items: [
      { name: { en: 'Mozzarella Sticks (6)', es: 'Palitos de Mozzarella (6)' }, price: '$8.00' },
      { name: { en: 'Chicken Fingers', es: 'Dedos de Pollo' }, price: '$8.00' },
      { name: { en: 'French Fries', es: 'Papas Fritas' }, price: '$6.00' },
      { name: { en: 'Garlic Knots (6)', es: 'Nudos de Ajo (6)' }, price: '$5.00' },
    ],
  },
  {
    id: 'salads',
    title: { en: 'Salads', es: 'Ensaladas' },
    items: [
      { name: { en: 'Garden Salad', es: 'Ensalada de Jardín' }, price: '$7.00' },
      { name: { en: 'Caesar Salad', es: 'Ensalada César' }, price: '$7.00' },
      { name: { en: 'Caprese Salad', es: 'Ensalada Caprese' }, price: '$7.00' },
      { name: { en: 'Add Grilled Chicken', es: 'Agregar Pollo a la Parrilla' }, price: '+$4.00' },
      { name: { en: 'Add Grilled Shrimp', es: 'Agregar Camarones a la Parrilla' }, price: '+$6.00' },
      { name: { en: 'Extras', es: 'Extras' }, price: '$3.00' },
    ],
  },
  {
    id: 'dinners',
    title: { en: 'Dinners', es: 'Cenas' },
    subtitle: { en: 'Served with pasta or mixed vegetables', es: 'Servido con pasta o vegetales mixtos' },
    items: [
      { name: { en: 'Chicken Francese', es: 'Pollo Francese' }, price: '$15.00' },
      { name: { en: 'Chicken Marsala', es: 'Pollo Marsala' }, price: '$15.00' },
      { name: { en: 'Chicken Scarpariello', es: 'Pollo Scarpariello' }, price: '$15.00' },
      { name: { en: 'Chicken Piccata', es: 'Pollo Piccata' }, price: '$15.00' },
    ],
  },
  {
    id: 'wings',
    title: { en: 'Buffalo Wings', es: 'Alitas Buffalo' },
    items: [
      { name: { en: 'Buffalo Wings (7)', es: 'Alitas Buffalo (7)' }, price: '$10.00' },
      { name: { en: 'Buffalo Wings (14)', es: 'Alitas Buffalo (14)' }, price: '$18.00' },
      { name: { en: 'Buffalo Wings (21)', es: 'Alitas Buffalo (21)' }, price: '$28.00' },
    ],
  },
  {
    id: 'soups',
    title: { en: 'Homemade Soups', es: 'Sopas Caseras' },
    items: [
      { name: { en: 'Pasta Fagioli', es: 'Pasta Fagioli' }, price: { en: 'Small $8.00 • Large $12.00', es: 'Pequeña $8.00 • Grande $12.00' } },
      { name: { en: 'Chicken Noodle', es: 'Sopa de Pollo con Fideos' }, price: { en: 'Small $8.00 • Large $12.00', es: 'Pequeña $8.00 • Grande $12.00' } },
    ],
  },
  {
    id: 'wraps',
    title: { en: 'Wraps', es: 'Wraps' },
    items: [
      { name: { en: 'Chicken Cutlet Wrap', es: 'Wrap de Milanesa de Pollo' }, price: '$12.00', desc: { en: 'With Fries', es: 'Con Papas' } },
      { name: { en: 'Chicken Caesar Wrap', es: 'Wrap César de Pollo' }, price: '$12.00', desc: { en: 'With Fries', es: 'Con Papas' } },
    ],
  },
  {
    id: 'calzones',
    title: { en: 'Calzones Roll', es: 'Rollos de Calzone' },
    items: [
      { name: { en: 'Cheese Calzone', es: 'Calzone de Queso' }, price: '$6.00' },
      { name: { en: 'Chicken Parm Roll', es: 'Rollo de Pollo Parmesano' }, price: '$6.00' },
      { name: { en: 'Pepperoni Roll', es: 'Rollo de Pepperoni' }, price: '$6.00' },
      { name: { en: 'Buffalo Roll', es: 'Rollo Buffalo' }, price: '$6.00' },
    ],
  },
  {
    id: 'catering',
    title: { en: 'Catering', es: 'Catering' },
    items: [
      { name: { en: 'Appetizers Catering', es: 'Catering de Aperitivos' }, price: { en: 'Half $55.00 • Full $80.00', es: 'Medio $55.00 • Completo $80.00' } },
      { name: { en: 'Mozzarella Sticks Catering', es: 'Catering de Palitos de Mozzarella' }, price: { en: 'Half $55.00 • Full $80.00', es: 'Medio $55.00 • Completo $80.00' } },
    ],
  },
];

export const translations = {
  en: {
    restaurantName: "Mirna's Pizza House",
    tagline: 'Authentic Italian Pizza & More',
    searchPlaceholder: 'Search pizza, wings, wraps...',
    all: 'All',
    callNow: 'Call Now',
    orderWhatsApp: 'Order via WhatsApp',
    yourOrder: 'Your Order',
    orderSummary: 'Order Summary',
    emptyCart: 'Your cart is empty.',
    addProducts: 'Add products to start your order.',
    remove: 'Remove',
    sendOrder: 'Send Order via WhatsApp',
    callRestaurant: 'Call Restaurant',
    address: 'Address',
    hours: 'Hours',
    hoursDetail: 'Open 7 Days',
    hoursMonSat: 'Mon–Sat: 10:00 AM – 9:00 PM',
    hoursSun: 'Sunday: 10:00 AM – 8:00 PM',
    addToCart: 'Add to Cart',
    itemAdded: 'Item added to cart!',
    deliveryAvailable: 'Delivery Available',
    options: 'options',
    whatsappGreeting: 'Hello Mirna\'s Pizza! I would like to order:',
  },
  es: {
    restaurantName: "Mirna's Pizza House",
    tagline: 'Pizza Italiana Auténtica y Más',
    searchPlaceholder: 'Buscar pizza, alitas, wraps...',
    all: 'Todo',
    callNow: 'Llamar Ahora',
    orderWhatsApp: 'Pedir por WhatsApp',
    yourOrder: 'Tu Pedido',
    orderSummary: 'Resumen del Pedido',
    emptyCart: 'Tu carrito está vacío.',
    addProducts: 'Agrega productos para comenzar tu pedido.',
    remove: 'Quitar',
    sendOrder: 'Enviar Pedido por WhatsApp',
    callRestaurant: 'Llamar al Restaurante',
    address: 'Dirección',
    hours: 'Horario',
    hoursDetail: 'Abierto 7 Días',
    hoursMonSat: 'Lun–Sáb: 10:00 AM – 9:00 PM',
    hoursSun: 'Domingo: 10:00 AM – 8:00 PM',
    addToCart: 'Agregar al Carrito',
    itemAdded: '¡Producto agregado al carrito!',
    deliveryAvailable: 'Delivery Disponible',
    options: 'opciones',
    whatsappGreeting: '¡Hola Mirna\'s Pizza! Me gustaría ordenar:',
  },
};
